<template>
  <div :class="rootKls">
    <div :class="colorsKls">
      <button v-for="(item, index) in rgbaColors" :key="colors[index]" type="button" :disabled="disabled"
        :aria-label="ariaLabel(item.value)" :class="colorSelectorKls(item)" @click="handleSelect(index)">
        <div :style="{ backgroundColor: item.value }" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { usePredefine, usePredefineDOM } from '../composables/use-predefine'
import { useLocale } from '@zoryn/hooks/use-locale'

import type { PredefineProps } from '../props/predefine'

defineOptions({
  name: 'ZColorPredefine',
})

const props = defineProps<PredefineProps>()

const { rgbaColors, handleSelect } = usePredefine(props)
const { rootKls, colorsKls, colorSelectorKls } = usePredefineDOM(props)
const { t } = useLocale()

const ariaLabel = (value: string) => {
  return t('z.colorpicker.predefineDescription', { value })
}
</script>
